import { Component, OnInit } from '@angular/core';
import { LocationService } from '../../core/services/location.service';
import { Environment } from '../../core/environment';
import { ProductName } from '../../core/graphql-client/graphql';

@Component({
  selector: 'finders-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  public locationTypeSelection = 'Treatment';
  public landingImage: string;
  public productIsProlia: boolean;
  public product: ProductName;

  constructor(
    private locationService: LocationService,
    private env: Environment
  ) {
    this.locationService.locationType$.subscribe(locationType => {
      this.locationTypeSelection = locationType;
    });

    this.productIsProlia = this.env.product === ProductName.Prolia;
    this.product = this.env.product;
  }

  ngOnInit() {
    const randomOneThroughFive = Math.floor(Math.random() * 5) + 1;
    this.landingImage = 'finder landing-image-' + randomOneThroughFive;
  }
}
